import moment from 'moment'
import Vue from 'vue'

import { getPage } from '@/config/customize'
import { statusOptions } from '@/constants/ticket3/ticketConstant'
import { roleOptions } from '@/constants/ticket3/userConstant'
import { CUSTOMER_SUPPORT_SERVICE_STATUS } from '@/constants/customer-support-service/ticketStatus'
import { FEATURE } from '@/constants/feature'
export default {
  securityToken: function (state) {
    return 'BEARER ' + state.userid + ' ' + state.accessToken
  },
  isLoading: function (state) {
    return state.loading
  },
  isLoggedIn: function (state) {
    return state.isLoggedIn
  },
  unsubscribedPage: function (state) {
    let pagelist = []
    if (state.pagelist) {
      pagelist = state.pagelist
        .map(function (pageValue) {
          let isFound = false
          if (state.botlist) {
            isFound = state.botlist.find((botValue) => botValue.pageid === pageValue.id)
          }
          return !isFound ? pageValue : null
        })
        .filter(Boolean)
    }

    return pagelist
  },
  allPage: function (state) {
    let pagelist = []

    if (state.pagelist) {
      pagelist = state.pagelist
        .map((pageValue) => {
          let isFound = false
          if (state.botlist) {
            isFound = state.botlist.find((botValue) => botValue.pageid === pageValue.id)
          }
          pageValue.isInstallBot = isFound ? true : false
          return pageValue
        })
        .filter(Boolean)
    }

    return pagelist
  },
  selectedBot: function (state) {
    if (state.selectedBot == null) {
      return null
    }

    var selectedBot = state.selectedBot

    var now = moment()
    var expriedDate = moment(state.selectedBot.expireat)
    selectedBot.expriedDate = parseInt(expriedDate.diff(now, 'days'))
    selectedBot.expriedTime = parseInt(expriedDate.diff(now, 'seconds'))
    try {
      var date = moment(selectedBot.livechat_expireat)
      var expriedLivechatTime = parseInt(date.diff(now, 'seconds'))
      selectedBot.isUnlockLivechat = expriedLivechatTime > 0 ? true : false
    } catch (error) {
      selectedBot.isUnlockLivechat = false
    }

    selectedBot.type = getPage(selectedBot.pageid)
    return selectedBot
  },
  botlist: function (state) {
    try {
      var bots = state.botlist.map((el) => {
        try {
          var now = moment()
          var date = moment(el.livechat_expireat)
          var expriedTime = parseInt(date.diff(now, 'seconds'))
          return {
            ...el,
            isUnlockLivechat: expriedTime > 0 ? true : false
          }
        } catch (error) {
          return {
            ...el,
            isUnlockLivechat: false
          }
        }
      })
    } catch (error) {
      return []
    }

    return bots
  },
  isSelectedBot: function (state) {
    return state.isSelectedBot
  },
  paypalTrackingId: function (state) {
    return state.paypalTrackingId
  },
  setting: function (state) {
    return state.setting
  },
  showModalWelcome: function (state) {
    return state.showModalWelcome
  },
  isFacebook: function (state) {
    return state.isFacebook
  },
  isCoachlab: function (state) {
    return state.selectedBot.pagetype == 'coachlab'
  },
  getPackage: function (state) {
    var now = moment()
    if (!state.selectedBot) {
      return 'normal'
    }
    var date = moment(state.selectedBot.expireat)
    var expriedTime = parseInt(date.diff(now, 'seconds'))
    return expriedTime > 0 ? 'premium' : 'normal'
  },
  currentLang: function () {
    return Vue.i18n.locale()
  },
  showAlert: (state) => (type) => {
    if (!state.selectedBot) {
      return -1
    }
    return state.alert.findIndex(function (el) {
      return el.name === type && el.pageid === state.selectedBot.pageid
    })
  },
  getCategories: function (state) {
    return state.ecommerce.categories
  },
  getBotPageRole: function (state) {
    let pagelist = []
    if (state.pagelist) {
      pagelist = state.pagelist
        .map(function (pageValue) {
          let isFound = false
          if (state.botlist) {
            isFound = state.botlist.find((botValue) => botValue.pageid === pageValue.id)
          }
          pageValue.isInstallBot = isFound ? true : false
          return pageValue
        })
        .filter(Boolean)
    }
    const bot = pagelist.find(function (val) {
      return val.id == state.selectedBot.pageid
    })
    if (bot) {
      if (bot.perms) {
        return bot.perms.indexOf('ADMINISTER') > -1
      } else if (bot.tasks) {
        return bot.tasks.indexOf('MANAGE') > -1
      }
    } else {
      return null
    }
  },
  getLoadingCategory: function (state) {
    return state.ecommerce.loadingCategory
  },
  getProducts: function (state) {
    return state.ecommerce.products
  },
  getLoadingProduct: function (state) {
    return state.ecommerce.loadingProduct
  },
  getUserStatus: function (state) {
    return state.userStatus
  },
  getLoadingUserStatus: function (state) {
    return state.loadingUserStatus
  },
  getLoadingSetting: function (state) {
    return state.loadingSetting
  },
  getSetting: function (state) {
    return state.setting
  },
  getLoadingCharges: function (state) {
    return state.ecommerce.loadingCharges
  },
  getCharges: function (state) {
    return state.ecommerce.charges
  },
  getLoadingLinePushMessageCount: function (state) {
    return state.linePushMessageCount
  },
  getLinePushMessageCount: function (state) {
    return state.loadingLinePushMessageCount
  },
  getLivechatUsers: function (state) {
    return (type) => {
      if (state.livechat && state.livechat.userlist[type]) {
        return state.livechat.userlist[type].users
      } else {
        return []
      }
    }
  },
  getCurrentUser: function (state) {
    return state.livechat.currentUser
  },
  allSchools: function (state) {
    return state.allSchools
  },
  getPageProfile: function (state) {
    return state.pageProfile
  },
  getLoadingPageProfile: function (state) {
    return state.loadingPageProfile
  },
  getLoadingPartnerProfile: function (state) {
    return state.loadingPartnerProfile
  },
  getPartnerProfile: function (state) {
    return state.partnerProfile
  },
  // ticketing
  getLoadingAgentGroup: function (state) {
    return state.loadingAgentGroups
  },
  getAgentGroup: function (state) {
    return state.agentGroups
  },
  getLoadingAgentSubgroup: function (state) {
    return state.loadingAgentSubgroups
  },
  getAgentSubgroup: function (state) {
    return state.agentSubgroups
  },
  getLoadingAgent: function (state) {
    return state.loadingAgents
  },
  getAgent: function (state) {
    return state.agents
  },
  isMonix: function (state) {
    return ['114683640172785'].includes(state.selectedBot.pageid)
  },
  isLivechatSearching: function (state) {
    return !(
      state.livechat.filter.search == '' &&
      state.livechat.filter.tags.length == 0 &&
      state.livechat.filter.status == null &&
      state.livechat.filter.app == '' &&
      state.livechat.filter.adminread == null &&
      !state.livechat.filter.uuAreaName &&
      !state.livechat.filter.uu_name &&
      !state.livechat.filter.phoneno &&
      !state.livechat.filter.uu_register_status &&
      !state.livechat.filter.lastconversationtodate &&
      !state.livechat.filter.lastconversationtotime &&
      !state.livechat.filter.lastconversationfromdate &&
      !state.livechat.filter.lastconversationfromtime &&
      !state.livechat.filter.assignadminname &&
      !state.livechat.filter.session &&
      !state.livechat.filter.realname &&
      !state.livechat.filter.cardnumber &&
      !state.livechat.filter.search
    )
  },
  getShippingAddress: function (state) {
    if (state.selectedBot == null && state.selectedBot.shopaddressarray == null) {
      return null
    }
    try {
      return JSON.parse(state.selectedBot.shopaddressarray)
    } catch (error) {
      return null
    }
  },
  getLoadingAstonAdmins: function (state) {
    return state.loadingAstonAdmins
  },
  getAstonAdmins: function (state) {
    return state.astonAdmins
  },
  getLivechatSearching(state) {
    var result = Object.keys(state.livechat.filter).map((key) => {
      return { name: key, value: state.livechat.filter[key] }
    }, [])
    return result.filter((el) => {
      return (
        el.value != '' && el.value != null && !(typeof el.value == Array && el.value.length == 0)
      )
    })
  },
  getDelayCustomerImport(state) {
    if (state.delayImportUserTime.length == 0) return true
    else {
      var delayTime = state.delayImportUserTime.find((el) => {
        return el.pageid == state.selectedBot.pageid
      })
      if (delayTime) {
        var now = moment()
        var date = moment(delayTime.time)
        return parseInt(date.diff(now, 'seconds'))
      } else {
        return true
      }
    }
  },
  getLivechatDetail: (state) => (type) => {
    switch (type) {
      case 'maxFetchUserTime':
        if (
          ['106855151601601', '102438735480946', '102052945584054'].includes(
            state.livechat.pageid
          ) ||
          ['cityfresh'].includes(state.livechat.theme)
        )
          return 10000 //10 sec
        else if (
          state.nestlePages.some((page) => page.pageid == state.livechat.pageid) ||
          [...state.bbqPage, '495271297476302', '236614096208182', ...state.kmbPage].includes(
            state.livechat.pageid
          ) ||
          ['summitcapital'].includes(state.livechat.theme)
        )
          return 30000 // 30 sec
        return state.livechat.maxFetchUserTime
      case 'maxFetchReadTime':
        if (
          ['106855151601601', '102438735480946', '102052945584054'].includes(
            state.livechat.pageid
          ) ||
          ['cityfresh'].includes(state.livechat.theme)
        )
          return 10000 //10 sec
        else if (
          state.nestlePages.some((page) => page.pageid == state.livechat.pageid) ||
          [...state.bbqPage, '495271297476302', '236614096208182', ...state.kmbPage].includes(
            state.livechat.pageid
          )
        )
          return 30000 // 30 sec
        return state.livechat.maxFetchReadTime
    }
    return null
  },
  welcomeMessage: (state, getters) => (type) => {
    var welcome_intent = getters.getIntents('welcome')
    let multichannel_welcome = false
    if (welcome_intent && welcome_intent.length > 0) {
      if (welcome_intent[0].fb_val || welcome_intent[0].line_val || welcome_intent[0].ig_val) {
        switch (type) {
          case 'facebook':
            try {
              multichannel_welcome = JSON.parse(welcome_intent[0].fb_val)
            } catch (error) {
              //
            }
            break
          case 'line':
            try {
              multichannel_welcome = JSON.parse(welcome_intent[0].line_val)
            } catch (error) {
              //
            }
            break
          case 'ig':
            try {
              multichannel_welcome = JSON.parse(welcome_intent[0].ig_val)
            } catch (error) {
              //
            }
            break

          default:
            break
        }
      }
    }
    if (multichannel_welcome) {
      return {
        multichannel: multichannel_welcome != false,
        messages: multichannel_welcome
      }
    }
    return {
      multichannel: false,
      messages:
        state.welcomeMessage && state.welcomeMessage.messages ? state.welcomeMessage.messages : [[]]
    }
  },
  getIntents: (state) => (type) => {
    if (!state.intents) {
      return []
    }
    if (type) {
      switch (type) {
        case 'intent':
          return state.intents.filter((el) => {
            return (
              el.context_in != 'comment' &&
              !['{welcome}', '{default}', '{default_comment_to_inbox}', '{default_live}'].includes(
                el.intentname
              )
            )
          })
        case 'comment':
          return state.intents.filter((el) => {
            return (
              el.context_in == 'comment' &&
              !['{welcome}', '{default}', '{default_comment_to_inbox}', '{default_live}'].includes(
                el.intentname
              )
            )
          })
        default:
          return state.intents.filter((el) => {
            return el.intentname == `{${type}}`
          })
      }
    } else return state.intents
  },
  getLoadingIntents: function (state) {
    return state.loadingIntents
  },
  livechat(state) {
    return state.livechat
  },
  currentUserTicket(state) {
    return state.currentUserTicket
  },
  currentUserTicketLoading(state) {
    return state.currentUserTicketLoading
  },
  getLoadingGroupConversation: function (state) {
    return state.loadingGroupConversation
  },
  getGroupConversation: function (state) {
    return state.groupConversation
  },
  ticketTags: function (state) {
    return state.ticketTags
  },
  ticketTagsFull: function (state) {
    return state.ticketTagsFull || []
  },
  showIntentGroup(state) {
    if (!state.selectedBot) {
      return false
    }
    return (
      [
        'ticket',
        'ticket2',
        'studio7',
        'ustore',
        'tdtawandang',
        'cityfresh',
        'nestle',
        ...state.ticketThemeList
      ].includes(state.selectedBot.theme) ||
      [...state.ticketPageid, ...state.rabbitReplyFBPostPage, ...state.toaPaintPage].includes(
        state.selectedBot.pageid
      ) ||
      ['gpf', 'mtc'].includes(state.selectedBot.type)
    )
  },
  intentTemplateData(state) {
    return state.intentTemplateData
  },
  ticketStatusOptions(state) {
    const options = statusOptions
    if (!state.selectedBot.unlock_survey) {
      const index = options.findIndex((el) => el.value == 'closed with survey')
      if (index != -1) {
        options.splice(index, 1)
      }
      const closeWithOutSurveyIndex = options.findIndex((el) => el.value == 'closed without survey')
      if (closeWithOutSurveyIndex != -1) {
        options[closeWithOutSurveyIndex].label = 'closed'
      }
    }
    return options
  },
  ticketRoleOptions() {
    return roleOptions
  },
  isFacebookConversionConnected(state, { selectedBot }) {
    return (
      selectedBot.facebook_ad_account_id &&
      selectedBot.page_access_token &&
      selectedBot.facebook_dataset_id
    )
  },
  // Customer Support Service
  isCustomerSupportService(state, { selectedBot }) {
    return (selectedBot.features || '').split(',').includes(FEATURE.CUSTOMER_SUPPORT_SERVICE)
  },
  customerStatusOptions(state, { selectedBot }) {
    const options = CUSTOMER_SUPPORT_SERVICE_STATUS
    if (!selectedBot.unlock_survey) {
      const index = options.findIndex((el) => el.value == 'closed with survey')
      if (index != -1) {
        options.splice(index, 1)
      }
    }
    return options
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js